import React, { useEffect, useState } from 'react';
import { Slide } from 'react-slideshow-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Slideshow.scss';
import land from './land.jpg'
import LandService from '../../../../service/LandService';
const slideImages = [
    {
        url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
        caption: 'Slide 1'
    },
    {
        url: 'https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80',
        caption: 'Slide 2'
    },
    {
        url: 'https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
        caption: 'Slide 3'
    },
];

const Image = ({imageId}) => {
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            try {   
                const image = await LandService.getImage(imageId, 'original');
                setImageSrc(image);
            } catch (error) {
                console.error("Failed to fetch image:", error);
            }
        };
        fetchImage();
    }, []);

    return (
        <img src={imageSrc} alt='land'/>
    )
};

const Slideshow = ({ listImage }) => {

    return (
        <div className="slide-container">
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                {listImage&& listImage.map((imageId, index) => (
                    <SwiperSlide key={index}>
                        <Image imageId={imageId}></Image>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default Slideshow